module.exports = __webpack_public_path__ + "img/calendar_icon.b87e0b99.svg";